import React from 'react';
import { AwardIcon, BookOpenIcon, EyeIcon, RouteIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
const ICONS = {
  route: RouteIcon,
  book: BookOpenIcon,
  eye: EyeIcon,
  award: AwardIcon
};
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-ink" data-id="element-16" data-mp="3nohvqazavswc">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-17" data-mp="3nmyg8mlgxlvm">
        <h2 id="beneficios" className="font-anton text-2xl uppercase leading-tight text-white sm:text-3xl" data-id="element-18" data-mp="38qh7820r4jc8">
          ¿Qué puede cambiar cuando empezás?
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-paper/80" data-id="element-19" data-mp="2zsx2uk7le6xe">
          Una habilidad práctica puede abrir nuevas posibilidades.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-20" data-mp="xzfypqio7o7e">
          {benefits.map((benefit, i) => {
          const Icon = ICONS[benefit.icon];
          return <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-lg border border-white/10 bg-white/5 p-2.5 text-left" data-id="element-21" data-mp="12wptllotws2m" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-forge" data-id="element-22" data-mp="2l58rf06kvg4u">
                  <Icon size={15} className="text-white" data-id="element-23" data-mp="2g77608loj4q7" />
                </span>
                <div data-id="element-24" data-mp="1sfjmibqqyvxy">
                  <h3 className="text-sm font-extrabold uppercase leading-tight text-gold" data-id="element-25" data-mp="1sh33k4k89b0s">
                    {benefit.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-paper/80 sm:text-sm" data-id="element-26" data-mp="22ehg3t315fnt">
                    {benefit.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}